<template>
  <v-snackbar v-model="visible" :top="true" :timeout="timeout" :color="type">{{ message }}</v-snackbar>
</template>

<script>
export default {
  name: "CMessage",
  data() {
    return {
      visible: false,
      type: "primary",
      timeout: 6000,
      message: ""
    };
  },
  // methods: {
  //   show(message, type = "primary") {
  //     this.message = message;
  //     this.type = type;
  //     this.visible = true;
  //   },
  //   close() {
  //     this.visible = false;
  //   },
  //   success(message) {
  //     this.show(message, "success");
  //   },
  //   error(message) {
  //     this.show(message, "error");
  //   }
  // }
};
</script>

<style>
</style>
